import {MAX_REPORT_SPAN_DAYS} from './MAX_REPORT_SPAN_DAYS';

const MILLISECONDS_PER_DAY = 86_400_000;

const toUtcTimestamp = (date: string) => Date.parse(`${date}T00:00:00.000Z`); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

/** True when `to - from` fits inside {@link MAX_REPORT_SPAN_DAYS}. */
export const isWithinMaxReportSpan = (from: string, to: string) =>
  (toUtcTimestamp(to) - toUtcTimestamp(from)) / MILLISECONDS_PER_DAY <= MAX_REPORT_SPAN_DAYS;
